import { render, staticRenderFns } from "./ShueiJinJiouItem.vue?vue&type=template&id=8fb65c86"
import script from "./ShueiJinJiouItem.vue?vue&type=script&lang=js"
export * from "./ShueiJinJiouItem.vue?vue&type=script&lang=js"
import style0 from "./ShueiJinJiouItem.vue?vue&type=style&index=0&id=8fb65c86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports